import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Observable} from "rxjs";

@Injectable()
export class SignUpTrialGuard implements CanActivate {



  constructor(
    private _router: Router,
  ) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return new Promise<boolean>((resolve, reject) => {
      this._router.navigate(['/checkout'], {
        queryParams: { ...next.queryParams, 'subscr_id': 211 }
      });
      resolve(false);
    });
  }



}
